




























import { Inject } from '@cds/common';
import { Component, Vue, Prop, Emit, Watch } from 'vue-property-decorator';
import { ADD, EDIT, DETAIL, ABILITY_OPTIONS } from '@/config/constant';
import { BasicInformationService } from '@/services/abilityAssessment/basic-information-service';
import { deepCopy } from '@/services/utils';
import { isEmpty, map, filter } from 'lodash';

@Component({
    components: {},
    filters: {
        resolveOperationType: (type: string | null) => type ? ABILITY_OPTIONS.operationType[type] : ""
    }
})
export default class LogDialog extends Vue {
    @Prop() private defaultData: object | null;
    @Emit() cancel() { }
    @Inject(BasicInformationService)
    private basicInformationService!: BasicInformationService;

    public ADD: string = ADD;
    public EDIT: string = EDIT;
    public DETAIL: string = DETAIL;
    public form: any = {
        size: 10,
        current: 1,
        total: 0
    };
    public tableData: any[] = [];
    public loading: Boolean = false;
    public labelPosition: String = 'right';
    public title: string = '操作日志';
    public visible: boolean = true;

    public async created(): Promise<void> {
        await this.getList();
    }
    // 初始化数据
    public initData() {
    }
    // 搜索
    public search() {
        this.form.current = 1;
        this.getList();
    }
    // 分页相关
    public handleSizeChange(size: number) {
        this.form.size = size;
        this.getList();
    }
    public handleCurrentChange(current: number) {
        this.form.current = current;
        this.getList();
    }
    // 获取数据源
    public async getList() {
        const { id } = this.defaultData as any;
        this.loading = true;
        const res = await this.basicInformationService.getAssessmentLog({ ...this.form, assessmentId: id });
        if (res) {
            this.tableData = res.records || [];
            this.form.total = res.total;
            this.form.size = res.size;
            this.form.current = res.current;
        }
        this.loading = false;
    }
    // 关闭自己
    public async handleClose() {
        try {
            await this.$confirm('确定要取消吗?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            });
            this.cancel();
        } catch (e) { }
    }
    // 重置
    public reset() {
        this.form = {
            size: 10,
            current: 1,
            total: 0
        };
        this.search();
    }
}
